<div class="logout-container">
  <div class="logout-message">
    <h2>You have been logged out successfully.</h2>
    <p>If you wish to access your account again, please <a href="/" class="login-link">click here to login</a>.</p>
  </div>
</div>